/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Print_SeatingInputs */



/**
* | output |
* | --- |
* | "Print seating" |
*
* @param {Rounds_Print_SeatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_print_seating = /** @type {((inputs?: Rounds_Print_SeatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Print_SeatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Imprimer le placement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imprimir la disposición")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Imprimir disposição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stampa la disposizione")
	return /** @type {LocalizedString} */ ("Print seating")
});